import sessionStore from '@/stores/session-store.js'
import serviceProviderStore from '@/stores/service-provider-store.js'
import axios from 'axios'
import { EventBus } from '../event-bus.js'

export default {
  data: function () {
    return {
      currentUser: {
        email: '',
        name: '',
        phone: '',
        isActive: '',
        phonePrefix: '',
        phoneIsVerified: false,
        id: null,
      },
    }
  },
  mounted() {
    this.fetchUser()
    sessionStore.subscribe(mutation => {
      if (['currentlyFetching', 'setUser'].indexOf(mutation.type) != -1) {
        this.fetchUser(true)
      }
    })
  },
  methods: {
    fetchUser(omitApiCall = false) {
      if (this.$isZabka && this.wasMsalLogoutWasPerformedLastTime()) {
        this.clearUser()
        this.removeMsalLogoutIndicator()
        this.redirectLogOutUserAwayFormAutomaticSSOLoginPage()
        return
      }

      if (!sessionStore.getters.currentlyFetching) {
        if (sessionStore.getters.token && !sessionStore.getters.user && !omitApiCall) {
          sessionStore.commit('currentlyFetching', true)
          console.log('%c WILL RESOLVE USER from db!', 'color: #67c9bb; font-weight: bold;')
          axios({
            method: 'get',
            url: 'auth/current_resource',
          })
            .then(response => {
              if (response.status == 200) {
                this.currentUser = response.data.user
                sessionStore.commit('setUser', response.data.user)

                // REPEATED CODE...
                if (response.data.user.isAdmin || response.data.user.hasAnyAdminMembers) {
                  this.$store.commit(
                    'setShowMyLockersOnly',
                    response.data.user.isAdmin || response.data.user.hasAnyAdminMembers,
                  )
                }
              }
              sessionStore.commit('currentlyFetching', false)
            })
            .catch(error => {
              console.error('error fetching user', error.response)
              sessionStore.commit('currentlyFetching', false)
              // this.$router.push('/');
            })
        } else if (sessionStore.getters.token && sessionStore.getters.user) {
          this.currentUser = sessionStore.getters.user
        } else if (
          (!sessionStore.getters.oktaAuth || !sessionStore.getters.oktaUser) &&
          this.authState?.isAuthenticated
        ) {
          this.oktaSetup()
        } else if (
          sessionStore.getters.oktaAuth &&
          sessionStore.getters.oktaUser.email &&
          this.authState?.isAuthenticated
        ) {
          this.getOktaUser()
        } else {
          this.currentUser = null
        }
      }
    },
    async oktaSetup() {
      sessionStore.commit('currentlyFetching', true)
      const user = await this.$auth.getUser()
      // airbrake.notify({
      //   error: new Error('oktaSetup'),
      //   context: { component: 'PWA' },
      //   params: { user: user },
      // })

      sessionStore.commit('setOktaAuth', true)
      sessionStore.commit('setOktaUser', user)
      sessionStore.commit('currentlyFetching', false)
      this.getOktaUser()
    },
    getOktaUser() {
      // airbrake.notify({
      //   error: new Error('before oktaFetching'),
      //   context: { component: 'PWA' },
      //   params: { oktaFetching: sessionStore.getters.oktaFetching },
      // })

      if (!sessionStore.getters.oktaFetching) {
        sessionStore.commit('currentlyFetching', true)
        sessionStore.commit('oktaFetching', true)
        const accessToken = this.$auth.getAccessToken()
        const idToken = this.$auth.getIdToken()
        const slug = window.location.host.split('.')[0]
        console.log('%c WILL RESOLVE OKTA USER from db!', 'color: #67c9bb; font-weight: bold;')
        axios({
          method: 'post',
          url: 'auth/okta_sign_in',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            token: idToken,
            slug: slug,
            email: sessionStore.getters.oktaUser.email,
            name: sessionStore.getters.oktaUser.name,
            phone: sessionStore.getters.oktaUser.phone,
            serviceProviderId: serviceProviderStore.getters.id,
          },
        })
          .then(response => {
            if (response.status == 200) {
              this.currentUser = response.data.user
              sessionStore.commit('setData', response.data.token)
              sessionStore.commit('setUser', response.data.user)
              EventBus.$emit(`showOnboardingAndModalsWhenLogin`)
              EventBus.$emit(`showAddToHomeScreenPrompt`)
              EventBus.$emit(`prefetchLockers`)
              this.setSkipLocationCheckTrue()
            }
          })
          .catch(error => {
            console.error('error fetching user', error.response)
            sessionStore.commit('currentlyFetching', false)
            sessionStore.commit('oktaFetching', false)
          })
          .finally(() => {
            sessionStore.commit('currentlyFetching', false)
            sessionStore.commit('oktaFetching', false)
          })
      }
    },
    setSkipLocationCheckTrue() {
      window.localStorage.setItem('skipLocalizationCheck', true)
    },
    wasMsalLogoutWasPerformedLastTime() {
      return localStorage.getItem('add_logout')
    },
    redirectLogOutUserAwayFormAutomaticSSOLoginPage() {
      this.$router.push('/aad-sso-sign-out')
    },
    clearUser() {
      sessionStore.commit('setData', null)
    },
    removeMsalLogoutIndicator() {
      localStorage.removeItem('add_logout')
    },
  },
}
